<template>
  <Loading v-if="componentLoading" :style="style" />
  <div v-else-if="visible" :style="style" :flex="flex">
    <template v-for="(item, index) in dataList" :key="item.id">
      <DynamicRender
        :config="{
          ...subComponentConfig,
          index: index + 1,
          data: item,
        }"
      />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from "vue"
import { v4 as uuidv4 } from "uuid"
import useToggle from "@p-v/hooks/useToggle"
import DynamicRender from "@p-v/packages/DynamicRender.vue"
import Loading from "@p-v/packages/Loading.vue"

const componentLoading = ref<boolean>(true)
const props = withDefaults(
  defineProps<{
    style: Record<string, any>
    subComponentConfig?: ComponentConnfig2_1
    flex?: string
    show: boolean
  }>(),
  {
    style: () => ({}),
    subComponentConfig: () => ({}),
    flex: () => "dir:top main:left corss:top",
    show: () => true,
  },
)
const { visible, show, hide, changeVisible } = useToggle(props.show)

const dataList = ref<any[]>([])

const loading = () => {
  componentLoading.value = true
}

const setData = (data: any[]) => {
  componentLoading.value = false

  dataList.value = data.map((item, index) => {
    return {
      ...item,
      id: uuidv4(),
    }
  })
}

defineExpose({
  show,
  hide,
  changeVisible,
  setData,
  loading,
})
</script>
